var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lp-tag"},[_c('div',{staticStyle:{"text-align":"center","margin":"25px auto"}},[_c('a',{attrs:{"href":"http://adtasukaru.com","target":"_blank","rel":"noopener noreferrer"}},[_c('el-button',{attrs:{"type":"primary"}},[_vm._v("トップへ")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }